
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { IPaymentCheckFormCC, IPaymentCheckFormExt, LGEDataService } from 'src/commons';
import { map, exhaustMap, from, of, catchError, switchMap, tap } from 'rxjs'

import {
  LoadPaymentCheckStateFail,
  PaymentCheckActionTypes,
  ValidateFail,
  UploadFail,

  LoadFormCCForValidateInvoiveState,
  LoadFormCCForValidateInvoiveStateSuccess,
  LoadFormCCForUploadStateSuccess,
  LoadFormCCForUploadState,
  LoadFormCCSentToOeBSStateSuccess,
  LoadFormCCSentToOeBSState,
  ValidateFormCC,
  SendToOeBSFormCC,
  LoadFormCCForControlReportState,
  GenerateControlReportFormCC,

  LoadFormCGForValidateInvoiveState,
  LoadFormCGForValidateInvoiveStateSuccess,
  ValidateFormCG,
  LoadFormCGForUploadState,
  LoadFormCGForUploadStateSuccess,
  SendToOeBSFormCG,
  LoadFormCGSentToOeBSState,
  LoadFormCGForControlReportState,
  LoadFormCGSentToOeBSStateSuccess,
  GenerateControlReportFormCG,

  LoadFormPPForValidateInvoiveState,
  LoadFormPPForValidateInvoiveStateSuccess,
  ValidateFormPP,
  LoadFormPPForUploadState,
  LoadFormPPForUploadStateSuccess,
  SendToOeBSFormPP,
  LoadFormPPSentToOeBSState,
  LoadFormPPForControlReportState,
  LoadFormPPSentToOeBSStateSuccess,
  GenerateControlReportFormPP,

  LoadFormESForValidateInvoiveState,
  LoadFormESForValidateInvoiveStateSuccess,
  ValidateFormES,
  LoadFormESForUploadState,
  LoadFormESForUploadStateSuccess,
  SendToOeBSFormES,
  LoadFormESSentToOeBSState,
  LoadFormESForControlReportState,
  LoadFormESSentToOeBSStateSuccess,
  GenerateControlReportFormES,

} from './payment-check.actions';

@Injectable()
export class PaymentCheckEffects {
  private data: any = {}
  private dataExt: any = {}

  constructor(
    private actions$: Actions,
    private lgeData: LGEDataService
  ) {
    this.data.statusId = '5';
    this.data.paymentMethod = 'CHECK';
    this.dataExt.statusId = '3';
    this.dataExt.paymentMethod = 'CHECK';
  }


  // formCC
  loadFormCCForValidateInvoiveState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormCCForValidateInvoiveState),
      exhaustMap(() =>
        from(this.lgeData.GetFormCCForValidateInvoive(this.data)).pipe(
          map((state: IPaymentCheckFormCC) => new LoadFormCCForValidateInvoiveStateSuccess(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )

  validateFormCC$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.ValidateFormCC),
      map((action: ValidateFormCC) => action.data),
      switchMap((data) => this.lgeData.ValidateApprovedFormCCAPI(data)),
      switchMap(() => [new LoadFormCCForValidateInvoiveState(), new LoadFormCCForUploadState()]),
      catchError(error => of(new ValidateFail(error, 'CC')))
    )
  )

  loadFormCCForUploadState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormCCForUploadState),
      exhaustMap(() =>
        from(this.lgeData.GetFormCCForUploadInvoive(this.data)).pipe(
          map((state: IPaymentCheckFormCC) => new LoadFormCCForUploadStateSuccess(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )

  sendToOeBSFormCC$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.SendToOeBSFormCC),
      map((action: SendToOeBSFormCC) => action.data),
      switchMap((data) => this.lgeData.UploadApprovedFormCCAPI(data)),
      switchMap(() => [new LoadFormCCForUploadState(), new LoadFormCCSentToOeBSState(), new LoadFormCCForControlReportState()]),
      catchError(error => of(new UploadFail(error, 'CC')))
    )
  )

  loadFormCCSentOeBSState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormCCSentToOeBSState),
      exhaustMap(() =>
        from(this.lgeData.GetFormCCForInvoiceSentToOeBS(this.data)).pipe(
          map((state: IPaymentCheckFormCC) => new LoadFormCCSentToOeBSStateSuccess(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )
  loadFormCCForControlReportState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormCCForControlReportState),
      exhaustMap(() =>
        from(this.lgeData.GetFormCCForControlReport()).pipe(
          map((state: IPaymentCheckFormCC) => new GenerateControlReportFormCC(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )

  generateCRFormCC$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.GenerateControlReportFormCC),
      map((action: GenerateControlReportFormCC) => action.data),
      tap((data) => this.lgeData.GenerateControlReportFormCC(data))
    )
  )

  // formCG
  loadFormCGForValidateInvoiveState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormCGForValidateInvoiveState),
      exhaustMap(() =>
        from(this.lgeData.GetFormCGForValidateInvoive(this.dataExt)).pipe(
          map((state: IPaymentCheckFormExt) => new LoadFormCGForValidateInvoiveStateSuccess(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )
  validateFormCG$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.ValidateFormCG),
      map((action: ValidateFormCG) => action.data),
      switchMap((data) => this.lgeData.ValidateApprovedFormExtAPI(data)),
      switchMap(() => [new LoadFormCGForValidateInvoiveState(), new LoadFormCGForUploadState()]),
      catchError(error => of(new ValidateFail(error, 'CG')))
    )
  )

  loadFormCGForUploadState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormCGForUploadState),
      exhaustMap(() =>
        from(this.lgeData.GetFormCGForUploadInvoive(this.dataExt)).pipe(
          map((state: IPaymentCheckFormExt) => new LoadFormCGForUploadStateSuccess(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )
  sendToOeBSFormCG$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.SendToOeBSFormCG),
      map((action: SendToOeBSFormCG) => action.data),
      switchMap((data) => this.lgeData.UploadApprovedFormExtAPI(data)),
      switchMap(() => [new LoadFormCGForUploadState(), new LoadFormCGSentToOeBSState(), new LoadFormCGForControlReportState()]),
      catchError(error => of(new UploadFail(error, 'CG')))
    )
  )


  loadFormCGSentOeBSState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormCGSentToOeBSState),
      exhaustMap(() =>
        from(this.lgeData.GetFormCGForInvoiceSentToOeBS(this.data)).pipe(
          map((state: IPaymentCheckFormExt) => new LoadFormCGSentToOeBSStateSuccess(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )
  loadFormCGForControlReportState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormCGForControlReportState),
      exhaustMap(() =>
        from(this.lgeData.GetFormCGForControlReport()).pipe(
          map((state: IPaymentCheckFormExt) => new GenerateControlReportFormCG(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )

  generateCRFormCG$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.GenerateControlReportFormCG),
      map((action: GenerateControlReportFormCG) => action.data),
      tap((data) => this.lgeData.GenerateExtControlReport(data))
    )
  )

  // formPP
  loadFormPPForValidateInvoiveState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormPPForValidateInvoiveState),
      exhaustMap(() =>
        from(this.lgeData.GetFormPPForValidateInvoive(this.dataExt)).pipe(
          map((state: IPaymentCheckFormExt) => new LoadFormPPForValidateInvoiveStateSuccess(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )
  validateFormPP$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.ValidateFormPP),
      map((action: ValidateFormPP) => action.data),
      switchMap((data) => this.lgeData.ValidateApprovedFormExtAPI(data)),
      switchMap(() => [new LoadFormPPForValidateInvoiveState(), new LoadFormPPForUploadState()]),
      catchError(error => of(new ValidateFail(error, 'PP')))
    )
  )

  loadFormPPForUploadState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormPPForUploadState),
      exhaustMap(() =>
        from(this.lgeData.GetFormPPForUploadInvoive(this.dataExt)).pipe(
          map((state: IPaymentCheckFormExt) => new LoadFormPPForUploadStateSuccess(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )
  sendToOeBSFormPP$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.SendToOeBSFormPP),
      map((action: SendToOeBSFormPP) => action.data),
      switchMap((data) => this.lgeData.UploadApprovedFormExtAPI(data)),
      switchMap(() => [new LoadFormPPForUploadState(), new LoadFormPPSentToOeBSState(), new LoadFormPPForControlReportState()]),
      catchError(error => of(new UploadFail(error, 'PP')))
    )
  )


  loadFormPPSentOeBSState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormPPSentToOeBSState),
      exhaustMap(() =>
        from(this.lgeData.GetFormPPForInvoiceSentToOeBS(this.data)).pipe(
          map((state: IPaymentCheckFormExt) => new LoadFormPPSentToOeBSStateSuccess(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )
  loadFormPPForControlReportState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormPPForControlReportState),
      exhaustMap(() =>
        from(this.lgeData.GetFormPPForControlReport()).pipe(
          map((state: IPaymentCheckFormExt) => new GenerateControlReportFormPP(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )

  generateCRFormPP$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.GenerateControlReportFormPP),
      map((action: GenerateControlReportFormPP) => action.data),
      tap((data) => this.lgeData.GenerateExtControlReport(data))
    )
  )

  // formES
  loadFormESForValidateInvoiveState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormESForValidateInvoiveState),
      exhaustMap(() =>
        from(this.lgeData.GetFormESForValidateInvoive(this.dataExt)).pipe(
          map((state: IPaymentCheckFormExt) => new LoadFormESForValidateInvoiveStateSuccess(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )
  validateFormES$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.ValidateFormES),
      map((action: ValidateFormES) => action.data),
      switchMap((data) => this.lgeData.ValidateApprovedFormExtAPI(data)),
      switchMap(() => [new LoadFormESForValidateInvoiveState(), new LoadFormESForUploadState()]),
      catchError(error => of(new ValidateFail(error, 'ES')))
    )
  )

  loadFormESForUploadState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormESForUploadState),
      exhaustMap(() =>
        from(this.lgeData.GetFormESForUploadInvoive(this.dataExt)).pipe(
          map((state: IPaymentCheckFormExt) => new LoadFormESForUploadStateSuccess(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )
  sendToOeBSFormES$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.SendToOeBSFormES),
      map((action: SendToOeBSFormES) => action.data),
      switchMap((data) => this.lgeData.UploadApprovedFormExtAPI(data)),
      switchMap(() => [new LoadFormESForUploadState(), new LoadFormESSentToOeBSState(), new LoadFormESForControlReportState()]),
      catchError(error => of(new UploadFail(error, 'ES')))
    )
  )


  loadFormESSentOeBSState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormESSentToOeBSState),
      exhaustMap(() =>
        from(this.lgeData.GetFormESForInvoiceSentToOeBS(this.data)).pipe(
          map((state: IPaymentCheckFormExt) => new LoadFormESSentToOeBSStateSuccess(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )
  loadFormESForControlReportState$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.LoadFormESForControlReportState),
      exhaustMap(() =>
        from(this.lgeData.GetFormESForControlReport()).pipe(
          map((state: IPaymentCheckFormExt) => new GenerateControlReportFormES(state)),
          catchError(error => of(new LoadPaymentCheckStateFail(error)))
        )
      )
    )
  )

  generateCRFormES$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.GenerateControlReportFormES),
      map((action: GenerateControlReportFormES) => action.data),
      tap((data) => this.lgeData.GenerateExtControlReport(data))
    )
  )
  // other
  validateFail$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.ValidateFail),
      map((action: ValidateFail) => {
        switch (action.formName) {
          case 'CC':
            return new LoadFormCCForValidateInvoiveState();
          case 'CG':
            return new LoadFormCGForValidateInvoiveState();
          case 'PP':
            return new LoadFormPPForValidateInvoiveState();
          case 'ES':
            return new LoadFormESForValidateInvoiveState();
          default:
            return new LoadFormCCForValidateInvoiveState();
          // case 'CI':
          //   return new LoadFormCIForValidateInvoiveState();
        }
      })
    )
  )
  
  uploadFail$ = createEffect(
    () => this.actions$.pipe(
      ofType(PaymentCheckActionTypes.UploadFail),
      map((action: UploadFail) => {
        switch (action.formName) {
          case 'CC':
            return new LoadFormCCForUploadState();
          case 'CG':
            return new LoadFormCGForUploadState();
          case 'PP':
            return new LoadFormPPForUploadState();
          case 'ES':
            return new LoadFormESForUploadState();
          default:
            return new LoadFormCCForUploadState();
          // case 'CI':
          //   return new LoadFormCIForValidateInvoiveState();
        }
      })
    )
  )

}






// // formCI
// @Effect()
// loadFormCIForValidateInvoiveState$: Observable < Action > = this.actions$
//   .ofType(PaymentCheckActionTypes.LoadFormCIForValidateInvoiveState)
//   .startWith(new LoadFormCIForValidateInvoiveState())
//   .exhaustMap(() =>
//     // You can pull from offline state here or get data from a server via an api
//     // An example of inserting data into offline state can be found in login.effects.ts
//     Observable.fromPromise(this.lgeData.GetFormCIForValidateInvoive(this.dataExt))
//       .map((state: IPaymentCheckFormExt) => new LoadFormCIForValidateInvoiveStateSuccess(state))
//       .catch(error => Observable.of(new LoadPaymentCheckStateFail(error)))
//   );

// @Effect()
// validateFormCI$: Observable < Action > = this.actions$
//   .ofType(PaymentCheckActionTypes.ValidateFormCI)
//   .map((action: ValidateFormCI) => action.data)
//   .exhaustMap((data) =>
//     // You can pull from offline state here or get data from a server via an api
//     // An example of inserting data into offline state can be found in login.effects.ts
//     Observable.fromPromise(this.lgeData.ValidateApprovedFormExtAPI(data))
//       .mergeMap(() => [new LoadFormCIForValidateInvoiveState(), new LoadFormCIForUploadState()])
//       .catch(error => Observable.of(new ValidateFail(error, 'CI')))
//   );

// @Effect()
// loadFormCIForUploadState$: Observable < Action > = this.actions$
//   .ofType(PaymentCheckActionTypes.LoadFormCIForUploadState)
//   .startWith(new LoadFormCIForUploadState())
//   .exhaustMap(() =>
//     // You can pull from offline state here or get data from a server via an api
//     // An example of inserting data into offline state can be found in login.effects.ts
//     Observable.fromPromise(this.lgeData.GetFormCIForUploadInvoive(this.dataExt))
//       .map((state: IPaymentCheckFormExt) => new LoadFormCIForUploadStateSuccess(state))
//       .catch(error => Observable.of(new LoadPaymentCheckStateFail(error)))
//   );

// @Effect()
// sendToOeBSFormCI$: Observable < Action > = this.actions$
//   .ofType(PaymentCheckActionTypes.SendToOeBSFormCI)
//   .map((action: SendToOeBSFormCI) => action.data)
//   .exhaustMap((data) =>
//     // You can pull from offline state here or get data from a server via an api
//     // An example of inserting data into offline state can be found in login.effects.ts
//     Observable.fromPromise(this.lgeData.UploadApprovedFormExtAPI(data))
//       .mergeMap(() => [new LoadFormCIForUploadState(), new LoadFormCISentToOeBSState(), new LoadFormCIForControlReportState()])
//       .catch(error => Observable.of(new UploadFail(error, 'CI')))
//   );

// @Effect()
// loadFormCISentOeBSState$: Observable < Action > = this.actions$
//   .ofType(PaymentCheckActionTypes.LoadFormCISentToOeBSState)
//   .startWith(new LoadFormCISentToOeBSState())
//   .exhaustMap(() =>
//     // You can pull from offline state here or get data from a server via an api
//     // An example of inserting data into offline state can be found in login.effects.ts
//     Observable.fromPromise(this.lgeData.GetFormCIForInvoiceSentToOeBS(this.dataExt))
//       .map((state: IPaymentCheckFormExt) => new LoadFormCISentToOeBSStateSuccess(state))
//       .catch(error => Observable.of(new LoadPaymentCheckStateFail(error)))
//   );

// @Effect()
// loadFormCIForControlReportState$: Observable < Action > = this.actions$
//   .ofType(PaymentCheckActionTypes.LoadFormCIForControlReportState)
//   // .startWith(new LoadFormCIForControlReportState())
//   .exhaustMap(() =>
//     // You can pull from offline state here or get data from a server via an api
//     // An example of inserting data into offline state can be found in login.effects.ts
//     Observable.fromPromise(this.lgeData.GetFormCIForControlReport())
//       .map((state: IPaymentCheckFormExt) => new GenerateControlReportFormCI(state))
//       .catch(error => Observable.of(new LoadPaymentCheckStateFail(error)))
//   );

// @Effect({ dispatch: false })
// generateCRFormCI$: Observable < Action > = this.actions$
//   .ofType(PaymentCheckActionTypes.GenerateControlReportFormCI)
//   .map((action: GenerateControlReportFormCI) => action.data)
//   .do((data) => this.lgeData.GenerateExtControlReport(data));